import React from 'react';
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction } from '@/components/ui/alert-dialog';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { MessageCircle } from 'lucide-react';

export const DeleteOrderDialog = ({ order, onCancel, onConfirm, deleting }) => (
  <AlertDialog open={!!order} onOpenChange={(open) => { if (!open) onCancel(); }}>
    <AlertDialogContent data-testid="delete-order-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete this order?</AlertDialogTitle>
        <AlertDialogDescription>
          {order && (
            <>
              This will permanently remove order for <span className="font-semibold">{order.dealer_name}</span>
              {order.delivery_date && <> scheduled <span className="font-semibold">{String(order.delivery_date).slice(0, 10)}</span></>}
              . This action cannot be undone.
            </>
          )}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="cancel-delete-order-btn" disabled={deleting}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          disabled={deleting}
          className="bg-red-600 hover:bg-red-700 text-white"
          data-testid="confirm-delete-order-btn"
        >
          {deleting ? 'Deleting…' : 'Delete'}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export const PostDispatchNotifyDialog = ({ notify, onSkip, onShare }) => (
  <Dialog open={!!notify} onOpenChange={(open) => { if (!open) onSkip(); }}>
    <DialogContent className="max-w-md" data-testid="post-dispatch-notify-dialog">
      <DialogHeader>
        <DialogTitle>Notify dealer on WhatsApp?</DialogTitle>
      </DialogHeader>
      <form onSubmit={(e) => { e.preventDefault(); onShare(); }}>
      {notify && (
        <div className="space-y-3">
          <p className="text-sm" style={{ color: '#5C6B61' }}>
            Order <span className="font-semibold">#{notify.order.id?.slice(0, 8)}</span> has been dispatched.
            Send vehicle & driver details to <span className="font-semibold">{notify.order.dealer_name}</span> on WhatsApp now?
          </p>
          <div className="p-3 rounded text-xs space-y-1" style={{ background: '#FBF9F6', color: '#1E2420' }}>
            <p><span style={{ color: '#5C6B61' }}>Vehicle:</span> <span className="font-medium">{notify.order.vehicle_number}</span></p>
            <p><span style={{ color: '#5C6B61' }}>Driver:</span> <span className="font-medium">{notify.order.driver_mobile}</span></p>
            <p><span style={{ color: '#5C6B61' }}>Dealer mobile:</span> <span className="font-medium">{notify.order.dealer_phone}</span></p>
          </div>
        </div>
      )}
      <DialogFooter className="mt-4 gap-2">
        <Button type="button" variant="outline" onClick={onSkip} data-testid="skip-whatsapp-notify-btn">
          Skip
        </Button>
        <Button
          type="submit"
          style={{ background: '#25D366', color: 'white' }}
          data-testid="confirm-whatsapp-notify-btn"
          autoFocus
        >
          <MessageCircle className="w-4 h-4 mr-2" /> Share on WhatsApp
        </Button>
      </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
